




















































import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import G01IconRanking from "@/general/components/pages/parts/Ranking/G01IconRanking.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import "swiper/swiper-bundle.css";
import commons from "@/common/store/modules/commons";

@Component({
  components: {
    Swiper,
    SwiperSlide,
    ItemListPanel,
    IconBase,
    IconArrowLeft,
    IconArrowRight,
    G01IconRanking
  }
})
export default class G01ItemCarousel extends Vue {
  @Prop({ type: Array, required: false }) items!: any;

  @Prop({ type: String, required: false, default: "default" })
  carouselName!: string;

  swiperOption = {
    slidesPerView: 5,
    spaceBetween: 16,
    slidesPerGroup: 5,
    // loop: true, // NOTICE: If set to true, click event will not be cloned.
    // loopFillGroupWithBlank: true,
    watchOverflow: true,
    navigation: {
      nextEl: `.p-g01-item-carousel--${this.carouselName} .p-g01-item-carousel__button--next`,
      prevEl: `.p-g01-item-carousel--${this.carouselName} .p-g01-item-carousel__button--prev`
    }
  };

  getImagePath(premium: any) {
    let imgUrl = "";
    premium?.premiumimage_set?.forEach((img: any) => {
      if (img?.is_primary == true) {
        imgUrl = img?.image_url;
      }
    });
    return imgUrl;
  }

  status(item: any) {
    if (item.is_quantity_control && item.quantity == 0) {
      //out of stock
      return "在庫なし";
    } else if (item.premium.is_new === true) {
      //New
      return "New";
    } else if (item.premium.is_featured === true) {
      //Recommended
      return "おすすめ";
    } else {
      //show nothing
      return false;
    }
  }

  getColor(item: any) {
    return item.is_quantity_control && item.quantity == 0
      ? "#333"
      : commons.colorCode;
  }
}
